/**
 * 
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserNotificationPushMessageResponse } from './user-notification-push-message-response';


export interface UserNotificationPushMessageResponsePagedList { 
    totalCount?: number;
    items?: Array<UserNotificationPushMessageResponse> | null;
}

